<template>
  <div class="manual-tools02-contents">
    <el-row>
      <el-col>
        <h2>ASPとアドタスカルを連携する（SCAN）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>【１】アドタスカルの「<router-link :to="`/tools02/${tool.codeKebab}/point-back`">ASP自動連携設定</router-link>」にアクセスします。</h4>
        <img :src="`${rt}/img/manual/${tool.codeKebab}/general/point-back.png`" alt="" />
        <h4>【２】SCANの通知URLをコピーします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no08/no06/01.png`" alt="" />
        <h4>【３】以下の文言をSCANの担当者に連絡します。</h4>
        <p>-----------------------<br>
          アドタスカルのポイントバック連携を希望します。<br>
          テスト案件でのテストコード発行もお願いします。<br>
          <br>
          （【２】でコピーしたSCANの通知URL）<br>
          -----------------------</p>
        <h4>【４】連携が完了すると、テスト案件用のURLが発行してもらえます。</h4>
        <img :src="`${rt}/img/manual/google-cv/no08/no06/02.png`" alt="" />
        <h4>【５】発行されたURLに「<span class="red">&amp;user_id={{tool.clickIdName}}_xxx</span>」を追記してください。</h4>
        <h5>▼発行されたテストURL</h5>
        <p>https://act.scadnet.com/cl/click.php?b_id=●●●&amp;t_id=t1</p>
        <h5>▼クリックパラメータを自分で付ける</h5>
        <p>https://act.scadnet.com/cl/click.php?b_id=●●●&amp;t_id=t1<span class="red">&amp;user_id={{tool.clickIdName}}_xxx</span></p>
        <p class="red">※自分で付けたパラメータを覚えておきましょう</p>
        <h4>【６】パラメータを付けたテストURLにアクセスして、「ここをクリックするとサンクスページ等に飛ぶ例の流れ」をクリックする。</h4>
        <div class="mini-img">
          <img :src="`${rt}/img/manual/google-cv/no08/no06/03.png`" alt="" />
        </div>
        <h4>【７】Thanksページが表示されます。これでテスト完了です。</h4>
        <div class="mini-img">
          <img :src="`${rt}/img/manual/google-cv/no08/no06/04.png`" alt="" />
        </div>
        <h4>【８】アドタスカルの「<router-link :to="`/tools02/${tool.codeKebab}/auto-import-log`">自動登録履歴</router-link>」を確認します。</h4>
        <img :src="`${rt}/img/manual/${tool.codeKebab}/general/log.png`" alt="" />
        <h4>【９】数分後に、テストCVが登録されていれば問題なく連携完了です。</h4>
        <AutoImportLog 
          :aspId="'6'"
          :aspPromotionName="'アドタスカル テスト'"
        />
        <ul>
          <li>ASP：SCAN</li>
          <li>CV時間：テストした時間になっているか？（多少の誤差はあり）</li>
          <li>プログラム名：-</li>
          <li>パラメータ：【５】で付けたパラメータと一致しているか？</li>
          <li>プログラムID： アドタスカル テスト</li>
          <li>報酬額：0</li>
          <li>インポート状況：「CLICK IDが取得不可」のエラーがあっても大丈夫です</li>
        </ul>
        <h4>【１０】連携完了</h4>
        <p>担当さんに一報入れましょう。これで連携は完了です。</p>
        <PointbackSettingDescription :aspId="'6'" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PointbackSettingDescription from "@/components/Manual/Tools02/No08/Parts/PointbackSettingDescription.vue";
import AutoImportLog from "@/components/Manual/Tools02/No08/Parts/AutoImportLog.vue";

export default {
  name: "ManualGoogleCvContents",
  components: {
    PointbackSettingDescription,
    AutoImportLog,
  },
  props: {
  },
  computed: {
    ...mapGetters(["rt","tool"]),
    tools() {
      return this.$store.getters.tools;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
